const LIMIT = 15;

const ORDER_STATUS = {
  SCHEDULED: "scheduled",
  SENT: "sent",
  CLAIMED: "claimed",
  REMINDED: "reminded",
  EXPIRED: "expired",

  REFUND_REQUESTED: "refund_requested",
  REFUND_REJECTED: "refund_rejected",
  REFUNDED: "refunded",
  CANCELLED: "cancelled",
};

let pendingRefund = { recipientId: null, claimId: null };

const BE_URL = "https://api.shadowbreeze.com";

const NO_OF_INITIALS_TO_DISPLAY = 3;

function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}


const GIFT_VALID_DAYS = 60; // 60 days

function getDaysLeft(dateString) {
  const startDate = new Date(dateString);
  const deadline = new Date(
    startDate.getTime() + GIFT_VALID_DAYS * 24 * 60 * 60 * 1000
  );
  const today = new Date();
  const diffTime = deadline.getTime() - today.getTime();
  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return daysLeft;
}

function getStatusDisplay(recipient, index, totalRecipients, linkOnly) {
  const status = recipient.status;
  const daysLeft = recipient.daysLeft;

  switch (status) {
    case ORDER_STATUS.CANCELLED: 
      return {
        badge: `<span class="status-badge status-expired">Cancelled</span>`,
        action: ``,
      };
    case ORDER_STATUS.SENT:
      if (daysLeft > 0) {
        return {
          badge: `<span class="status-badge status-sent">${daysLeft} days left</span>`,
          action: `${
            linkOnly
              ? `<div class="copy-link-btn" data-link="${recipient.giftLink}">Copy Link</div>`
              : ""
          }`,
        };
      } else {
        return {
          badge: `<span class="status-badge status-expired">Expired</span>`,
          action: `<button class="action-btn btn-refund">Ask for refund</button>`,
        };
      }

    case ORDER_STATUS.REMINDED:
      const reminderRadio = (label, isChecked, id) => `
        <label class="reminder-radio" for="${id}">
          <input type="radio" id="${id}" name="reminder-status" disabled ${
        isChecked ? "checked" : ""
      }>
          ${label}
        </label>
      `;

      return {
        badge: `<span class="status-badge status-reminded">${daysLeft} days left</span>`,
        action: `
          <div class="tooltip-container">
            <button class="action-btn btn-reminder">Reminder sent</button>
            <div class="custom-tooltip ${
              totalRecipients > 3 && index == 0 && "tooltip-down"
            }">
              ${reminderRadio("30 days", recipient.reminder30Sent, "r30")}
              ${reminderRadio("14 days", recipient.reminder14Sent, "r14")}
              ${reminderRadio("7 days", recipient.reminder7Sent, "r7")}
              ${reminderRadio("Admin", recipient.adminReminderSent, "radmin")}
            </div>
          </div>
        `,
      };

    case ORDER_STATUS.EXPIRED:
      return {
        badge: `<span class="status-badge status-expired">Expired</span>`,
        action: `<button
                  class="action-btn btn-refund"
                   data-recipient-id="${recipient._id}"
               data-claim-id="${recipient.claimId}"
                  
                >Ask for refund</button>`,

        // onclick="handleRefundRequest('${recipient._id}', '${recipient.claimId}')"
      };

    case ORDER_STATUS.CLAIMED:
      return {
        badge: `<span class="status-badge status-claimed">Claimed</span>`,
        action: ``,
      };

    case ORDER_STATUS.REFUND_REQUESTED:
      return {
        badge: `<span class="status-badge status-expired">Expired</span>`,
        action: `<button class="action-btn btn-info">Refund Requested</button>`,
      };

    case ORDER_STATUS.REFUND_REJECTED:
      return {
        badge: `<span class="status-badge status-expired">Expired</span>`,
        action: `<div class="tooltip-container">
        <button class="action-btn btn-rejected">Refund Rejected</button>
                <div class="custom-tooltip">${recipient.rejectReason}</div>
            </div>
        `,
      };

    case ORDER_STATUS.REFUNDED:
      return {
        badge: `<span class="status-badge status-refund">Refund Processed</span>`,
        action: ``,
      };

    case ORDER_STATUS.SCHEDULED:
      return {
        badge: `<span class="status-badge status-scheduled">Scheduled</span>`,
        action: ``,
      };

    default:
      // Fallback for unknown or expired based on time
      return {
        badge: `<span class="status-badge status-expired">Expired</span>`,
        action: `<button class="action-btn btn-refund">Ask for refund</button>`,
      };
  }
}

function checkHeight() {
  const modalBody = document.querySelector(".orders-modal-body");
  console.log("modal height  -- ", modalBody.offsetHeight);
  if (modalBody.offsetHeight >= 400) {
    console.log("inside the offsetHeight");
    modalBody.style.overflowY = "auto";
  } else {
    modalBody.style.overflowY = "visible";
  }
}

function openRecipientModal(orderId, recipients, linkOnly = false) {
  console.log("inside open modal ", {orderId, recipients, linkOnly})  
  const modal = document.getElementById("orders-modal-overlay");
  const modalBody = document.getElementById("orders-modal-body");
  const modalSubtitle = document.getElementById("orders-modal-subtitle");
  modalSubtitle.textContent = `Order: #${orderId}`;

  // Clear existing content
  modalBody.innerHTML = "";

  // Populate recipients
  const totalRecipients = recipients.length;
  recipients.forEach((recipient, index) => {
    const statusInfo = getStatusDisplay(
      recipient,
      index,
      totalRecipients,
      linkOnly
    );
    console.log("onclick called", statusInfo);

    const recipientDiv = document.createElement("div");
    recipientDiv.className = "recipient-item";

    recipientDiv.innerHTML = `
                <div class="recipient-name">${recipient?.name || "- - - "}</div>
                <div class="recipient-email">${
                  recipient?.email || "- - - "
                }</div>
                ${statusInfo.badge}
                ${statusInfo.action}
        `;

    modalBody.appendChild(recipientDiv);
  });

  // Show modal
  modal.classList.add("active");
  document.body.style.overflow = "hidden";
  checkHeight();
}

function closeRecipientModal() {
  const modal = document.getElementById("orders-modal-overlay");
  modal.classList.remove("active");
  document.body.style.overflow = "auto";
}

document
  .getElementById("orders-modal-overlay")
  .addEventListener("click", function (e) {
    if (e.target === this) {
      closeRecipientModal();
    }
  });

// Close modal with Escape key
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    closeRecipientModal();
  }
});

async function handleRefundRequest(recipientId, claimId) {
  try {
    console.log("function called ", recipientId, claimId);

    const response = await fetch(`${BE_URL}/claims/refund/request`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
      body: JSON.stringify({ claimId }),
    });
    const result = await response.json();
    if (result.success) {
      const button = document.querySelector(
        `.action-btn.btn-refund[data-recipient-id="${recipientId}"]`
      );
      if (button) {
        const parentDiv = button.closest(".recipient-item");
        if (parentDiv) {
          parentDiv.querySelector(
            ".status-badge"
          ).outerHTML = `<span class="status-badge status-expired">Expired</span>`;
          button.outerHTML = `<button class="action-btn btn-info">Refund Requested</button>`;
        }
      }
    } else {
      console.log("Failed to submit refund request.");
    }
  } catch (err) {
    console.error("Error submitting refund request:", err);
  }
}

async function fetchOrders(page = 1) {
  try {
    console.log("Customer ID:", window.customerId);
    const customerId = window.customerId;
    // const customerId = 8070693290212;
    // const customerId = 5464964169893;
    const url = `${BE_URL}/orders/${customerId}?page=${page}&limit=${LIMIT}`;
    const tbody = document.getElementById("orders-body");

    tbody.innerHTML =
      ' <td colspan=6> <div class="center"> <div class="loading-spinner"></div> </div></td>';

    const response = await fetch(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });

    if (!response.ok) throw new Error("Network response was not ok");
    const orders = await response.json();
    console.log({ orders });
    const ordersData = orders?.data?.items;
    const paginationData = orders?.data?.pagination;
    console.log({ ordersData });
    if (!ordersData || ordersData <= 0) {
      tbody.innerHTML = "<p class='empty-para'> No data found </p>";
      return;
    }

    console.log({ orders });

    // const tbody = document.getElementById("orders-body");
    tbody.innerHTML = "";

    ordersData.forEach((order) => {
      let initialsHTML = "";
      if (order.recipient && order.recipient.length > 0) {
        const visibleRecipients = order.recipient.slice(
          0,
          NO_OF_INITIALS_TO_DISPLAY
        );
        const remainingCount =
          order.recipient.length - NO_OF_INITIALS_TO_DISPLAY;

        const initialsElements = visibleRecipients.map((r, index) => {
          const parts = r?.trim().split(" ").filter(Boolean);
          let initials = "";
          if (parts.length === 1) {
            initials = parts[0].substring(0, 2).toUpperCase();
          } else {
            initials = (parts[0][0] || "") + (parts[1][0] || "");
            initials = initials.toUpperCase();
          }

          return `<span class="initial-circle ${
            index !== 0 ? "negative-margin" : ""
          }">${initials}</span>`;
        });

        if (remainingCount > 0) {
          initialsElements.push(
            `<span class="initial-circle more-indicator">+${remainingCount}</span>`
          );
        }

        initialsHTML = `<div class="initials-container">${initialsElements.join(
          ""
        )}</div>`;
      } else {
        initialsHTML = `<div class="initials-container"><div style="cursor: pointer;"> --- </div></div>`;
      }

      const row = document.createElement("tr");
      row.className = "table-row";
      // console.log("recipients data - ", orders.recipients)
      const idCell = `<td class="table-cell recipient-name"> #${order.id}</td>`;
      const budgetCell = `<td class="table-cell order-budget"> $${order.giftAmount} </td>`;
      const nameCell = order?.recipients
        ? `<td class="table-cell recipient-name intial-circle" onclick="openRecipientModal('${
            order.id
          }', ${JSON.stringify(order?.recipients).replace(/"/g, "&quot;")}, ${
            order.linkOnly
          })">${initialsHTML}</td>`
        : "<td>N/A</td>";
      const emailCell = order?.recipients[0]?.email
        ? `<td class="table-cell recipient-email">${order?.recipients[0]?.email} </td>`
        : "<td>N/A</td>";
      const dateCell = `<td class="table-cell recipient-email">${formatDate(
        order.date
      )} </td>`;

      const scheduleDateCell = `<td class="table-cell created-date">${formatDate(
        order.scheduledDate
      )}</td>`;

      row.innerHTML =
        idCell +
        budgetCell +
        nameCell +
        emailCell +
        dateCell +
        scheduleDateCell;
      tbody.appendChild(row);
    });

    if (paginationData) {
      document.querySelector(".pagination-wrapper").classList.remove("hide");
      document.getElementById("totalPages").textContent =
        paginationData.totalPages;
      document.getElementById("currentPage").textContent =
        paginationData.currentPage;
      const prevBtn = document.getElementById("prevBtn");
      if (paginationData.currentPage === 1) {
        prevBtn.classList.add("disabled");
        prevBtn.style.pointerEvents = "none";
        prevBtn.style.opacity = "0.5";
      } else {
        prevBtn.classList.remove("disabled");
        prevBtn.style.pointerEvents = "auto";
        prevBtn.style.opacity = "1";
      }

      const nextBtn = document.getElementById("nextBtn");
      if (paginationData.currentPage === paginationData.totalPages) {
        nextBtn.classList.add("disabled");
        nextBtn.style.pointerEvents = "none";
        nextBtn.style.opacity = "0.5";
      } else {
        nextBtn.classList.remove("disabled");
        nextBtn.style.pointerEvents = "auto";
        nextBtn.style.opacity = "1";
      }
    }

    handleRefundRequest();
  } catch (err) {
    console.log("error in fetching data", err);
  }
}

async function handlePagination(direction) {
  const currentPageElem = document.getElementById("currentPage");
  const totalPagesElem = document.getElementById("totalPages");

  let currentPage = parseInt(currentPageElem.textContent, 10);
  const totalPages = parseInt(totalPagesElem.textContent, 10);

  if (direction === "next" && currentPage < totalPages) {
    currentPage++;
  } else if (direction === "prev" && currentPage > 1) {
    currentPage--;
  }

  // Update page number in UI
  currentPageElem.textContent = currentPage;

  // Call your async function
  await fetchOrders(currentPage);

  // Scroll to top of form (optional)
  // requestAnimationFrame(() => {
  //   const wrapper = document.querySelector('.multi-form-wrapper');
  //   if (wrapper) {
  //     wrapper.scrollTo({ top: 0, behavior: 'smooth' });
  //   }
  // });
}

document.addEventListener("DOMContentLoaded", async () => {
  await fetchOrders();

  document.body.addEventListener("click", (e) => {
    if (e.target.classList.contains("btn-refund")) {
      pendingRefund.recipientId = e.target.dataset.recipientId;
      pendingRefund.claimId = e.target.dataset.claimId;

      document
        .getElementById("refund-confirm-modal")
        .classList.remove("hidden");
      document.body.style.overflow = "hidden";
    }
  });

  document.getElementById("refund-cancel-btn").addEventListener("click", () => {
    document.getElementById("refund-confirm-modal").classList.add("hidden");
    document.body.style.overflow = "auto";
    pendingRefund = { recipientId: null, claimId: null };
  });

  document
    .getElementById("refund-proceed-btn")
    .addEventListener("click", async () => {
      document.getElementById("refund-confirm-modal").classList.add("hidden");
      document.body.style.overflow = "auto";

      if (pendingRefund.recipientId && pendingRefund.claimId) {
        await handleRefundRequest(
          pendingRefund.recipientId,
          pendingRefund.claimId
        );
        pendingRefund = { recipientId: null, claimId: null };
      }
    });

  document.getElementById("nextBtn").addEventListener("click", () => {
    handlePagination("next");
  });

  document.getElementById("prevBtn").addEventListener("click", () => {
    handlePagination("prev");
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".copy-link-btn");
    if (btn) {
      const link = btn.getAttribute("data-link");
      if (link) {
        navigator.clipboard
          .writeText(link)
          .then(() => {
            // Optional: give feedback
            btn.textContent = "Copied!";
            setTimeout(() => (btn.textContent = "Copy Link"), 1500);
          })
          .catch((err) => {
            console.error("Failed to copy:", err);
          });
      }
    }
  });

  // window.addEventListener("", checkHeight);
});
